"use strict";
export const accessForm = (data) => ({
    open: false,
    currentView: 'login', // Allowed values "login" and "signup"
    success: false,
    loading: false,
    passwordConfirmation: data.passwordConfirmation,
    firstName: data.firstName,
    lastName: data.lastName,
    remember: data.remember,
    showPassword: false,
    showPasswordConfirmation: false,
    currentError: '',
    termsAccepted: data.termsAccepted,
    email: data.email,
    password: data.password,
    isLoggedIn: data.isLoggedIn,
    termsErrorMessage: data.termsErrorMessage,
    loginErrorMessage: data.loginErrorMessage,
    loginSubmitLabel: data.loginSubmitLabel,
    signupSubmitLabel: data.signupSubmitLabel,
    loginAction: data.loginAction,
    signupAction: data.signupAction,
    ajaxUrl: data.ajaxUrl,
    passwordsMatchErrorMessage: data.passwordsMatchErrorMessage,
    nonce: data.nonce,
    checkPasswordsMatch() {
        if (this.password.length && this.passwordConfirmation.length) {
            if (this.password !== this.passwordConfirmation) {
                this.currentError = this.passwordsMatchErrorMessage;
                return false;
            }
        }
        return true;
    },
    openModal() {
        this.open = true;
        if (this.currentView === 'signup') {
            this.$nextTick(() => {
                document.getElementById("first_name")?.focus();
            });
        } else {
            this.$nextTick(() => {
                document.getElementById("email")?.focus();
            });
        }
    },
    async submit() {
        this.loading = true;
        if (this.currentView === 'signup') {
            if (!await this.signup()) {
                this.loading = false;
            }
        } else {
            if (!await this.login()) {
                this.loading = false;
            }
        }
    },

    async login() {
        const body = {
            email: this.email,
            password: this.password,
            remember: this.remember,
            nonce: this.nonce
        };
        const response = await this.getResponse(this.loginAction, body);

        if (response.success) {
            this.success = true;
            window.location.reload();
            return true;
        }
        this.currentError = response.data;
        return false
    },
    async signup() {
        if (!this.checkPasswordsMatch()) {
            return false;
        }

        if (!this.termsAccepted) {
            this.currentError = this.termsErrorMessage;
            return false
        }

        const body = {
            email: this.email,
            password_confirmation: this.passwordConfirmation,
            password: this.password,
            remember: this.remember,
            first_name: this.firstName,
            last_name: this.lastName,
            terms: this.termsAccepted,
            nonce: this.nonce
        }
        const response = await this.getResponse(this.signupAction, body);
        if (response.success) {
            this.success = true;
            window.location.reload();
            return true;
        }
        this.currentError = response.data;
        return false;

    },
    async getResponse(action, body) {
        let formData = new FormData();
        for (let key in body) {
            formData.append(key, body[key]);
        }
        return await (await fetch(`${this.ajaxUrl}?action=${action}`, {
            method: 'POST',
            body: formData,
        })).json()
    }

});